import React from 'react';

export const Logo = ({ variant = 'dark' }) => {
  const isDark = variant === 'dark';
  
  return (
    <svg width="200" height="40" viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0" y="2" width="34" height="34" rx="7" fill={isDark ? "#0F2742" : "white"} fillOpacity={isDark ? 1 : 0.15}/>
      <rect x="3.5" y="9" width="1.8" height="20" rx="0.9" fill="white" fillOpacity="0.28"/>
      <rect x="7.5" y="10" width="20" height="2.8" rx="1.4" fill="white"/>
      <rect x="7.5" y="16.5" width="13" height="2" rx="1" fill="white" fillOpacity="0.72"/>
      <rect x="7.5" y="21" width="18" height="2" rx="1" fill="white" fillOpacity="0.5"/>
      <rect x="7.5" y="25.5" width="10" height="2" rx="1" fill="white" fillOpacity="0.32"/>
      <text x="44" y="18" fontFamily="DM Sans, sans-serif" fontSize="13.5" fontWeight="700" letterSpacing="0.045em" fill={isDark ? "#0F2742" : "white"}>SCHEDULES</text>
      <text x="44" y="32" fontFamily="DM Sans, sans-serif" fontSize="10.5" fontWeight="300" letterSpacing="0.17em" fill={isDark ? "#6B7280" : "white"}>OF WORKS</text>
    </svg>
  );
};
